<template>
    <NewPreOrderUnit
        v-if="preOrder"
        :manufacturers="manufacturers"
        @searchManufacturers="executeManufacturerSearch"
        @addUnit="addUnit"
        @cancel="cancel"
    />
</template>
<script>
import { mapActions } from "vuex";
import store from "./_store";
import NewPreOrderUnit from "./_components/NewPreOrderUnit.vue";
import { mutations } from "src/global-store.js";

export default {
    name: "NewPreOrderUnitModule",
    components: {
        NewPreOrderUnit,
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.fromPath = from.path;
        });
    },
    props: {
        preOrder: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            fromPath: null,
            manufacturers: [],
        };
    },
    computed: {
        customerName() {
            let client = this.preOrder?.customer?.name;
            if (this.preOrder?.designer) {
                client = `${client} (${this.preOrder.designer?.fullName})`;
            }
            return client;
        },
    },
    beforeCreate() {
        this.$store.registerModule("$_preOrderUnit", store);
    },
    destroyed() {
        this.$store.unregisterModule("$_preOrderUnit");
    },
    created() {
        if (!this.preOrder) {
            this.$router.push(`/preorder/${this.$route.params.id}`);
        }
        mutations.setNavbarTitle("New PreOrder Unit", this.customerName);
    },
    methods: {
        ...mapActions("$_preOrderUnit", ["addPreOrderUnit"]),
        ...mapActions("manufacturer", ["searchManufacturers"]),
        cancel() {
            this.$router.push(`/preorder/${this.preOrder.id}`);
        },
        async addUnit(unit) {
            await this.addPreOrderUnit({
                preOrderId: this.preOrder.id,
                ...unit,
            });
            // go back to allow additional adding of units
            // replace, not push so back button doesn't take us back here
            const to = `/preorder/${this.$route.params.id}`;
            if (this.fromPath === to) {
                this.$router.back();
            } else {
                this.$router.replace(to);
            }
        },
        async executeManufacturerSearch({ search, loading }) {
            loading(true);
            this.manufacturers = await this.searchManufacturers(search);
            loading(false);
        },
    },
};
</script>
